import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header-section" }
const _hoisted_2 = {
  key: 0,
  class: "header-link__tag"
}

import {getSliceComponentProps} from '@prismicio/vue';
    import ServerSideNavigationPrismicLink from '../components/ServerSideNavigationPrismicLink.vue';
    import {linkResolver} from '../helpers/link-resolver';
    import {HeaderLinksSliceSlice, HeaderLinksSliceSliceDefaultItem} from '@/unlogged/prismicio';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderLinksSlice',
  props: getSliceComponentProps<HeaderLinksSliceSlice>(),
  setup(__props) {

    

    function shoudDisplay(item: HeaderLinksSliceSliceDefaultItem) {
        return !item.abTest;
        // const [campaignId, variationId] = item.abTest.split('.');
        // return getVariation(campaignId) === variationId;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slice.items, (item, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: `slice-item-${i}`
      }, [
        (shoudDisplay(item))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["header-link", {'header-link--has-tag': item.tag}])
            }, [
              (item.tag)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(item.tag), 1))
                : _createCommentVNode("", true),
              _createVNode(ServerSideNavigationPrismicLink, {
                field: item.link,
                "link-resolver": _unref(linkResolver)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.linkText), 1)
                ]),
                _: 2
              }, 1032, ["field", "link-resolver"])
            ], 2))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})